// extracted by mini-css-extract-plugin
export default {"register":"Register_register__H6uKZ","form_container":"Register_form_container__1X1zV","btn":"Register_btn__Od0XL","error":"Register_error__banC6"};